module.exports = __webpack_public_path__ + "static/whatsapp-phone-en-4bffa75cf6f20cebbd04a4e839a21e0c.png";